<template>
  <v-container v-if="loading">
    <div class="text-xs-center">
      <v-progress-circular
        indeterminate
        :size="150"
        :width="8">
      </v-progress-circular>
    </div>
  </v-container>

  <v-container v-else fluid grid-list-md>
    <v-layout column>
      <v-flex xs12 sm6 v-if="!isList" >
        <v-card>
          <grid-cards v-bind:recalls="recalls" v-bind:noData="noData"></grid-cards>
          <v-flex xs12>
            <v-btn @click="fetchRecallData">Load More</v-btn>
          </v-flex>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-else>
        <v-card>
          <list-cards v-bind:recalls="recalls" v-bind:noData="noData"></list-cards>
          <v-flex xs12>
            <v-btn @click="fetchRecallData">Load More</v-btn>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import * as moment from 'moment/moment'
import recallApi from '@/services/RecallApi'

export default {
  name: 'RecallList',
  props: ['year'],
  created () {
    window.bus.$on('emitListView', (args) => {
      this.isList = args.isList
    })
  },
  data () {
    return {
      recalls: [],
      show: false,
      isList: false,
      startDate: '',
      endDate: null,
      searchString: null,
      loading: true,
      noData: false,
      isFirst: true
    }
  },
  methods: {
    fetchRecallData () {
      this.setStartDate()
      this.setEndDate()

      recallApi.fetchRecallCollection(this.startDate, this.endDate, this.searchString)
        .then(response => {
          if (Object.keys(response).length) {
            // this.recalls = response
            this.recalls = this.recalls.concat(response)
            this.loading = false
            this.noData = false
            this.isFirst = false
          } else {
            this.noData = true
            this.loading = false
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
    },
    setStartDate () {
      if (this.year) {
        this.startDate = this.year + '-01-01'
      } else {
        if (!this.startDate) {
          // eslint-disable-next-line new-cap
          var firstDayPreviousMonth = new moment().subtract(1, 'months').date(1)
          this.startDate = firstDayPreviousMonth.format('YYYY-MM-DD')
        }
      }
    },
    setEndDate () {
      if (this.year) {
        this.endDate = this.year + '-12-31'
      } else {
        if (!this.isFirst) {
          var currentStartDate = this.startDate
          var firstDayPriorMonth = moment(currentStartDate).subtract(1, 'months')
          var lastDayFromStartDate = moment(currentStartDate).subtract(1, 'days')
          this.startDate = firstDayPriorMonth.format('YYYY-MM-DD')
          this.endDate = lastDayFromStartDate.format('YYYY-MM-DD')
        }
      }
    }
  },
  mounted () {
    this.fetchRecallData()
  }
}
</script>
